import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipModalService {

  private selectedShipSubject = new BehaviorSubject<any>(null);
  public selectedShip$ = this.selectedShipSubject.asObservable();

  constructor() { }

  setSelectedShip(ship: any): void {
    this.selectedShipSubject.next(ship);
  }

  getSelectedShip(): any | null {
    return this.selectedShipSubject.value;
  }

  clearSelectedShip(): void {
    this.selectedShipSubject.next(null);
  }
}
